import type { AssistantFollowUpObservable } from "@/store/assistant";
// Imported from the defining module rather than the barrel, which would pull the
// sync-model classes into every consumer of these pure helpers.
import { AssistantFollowUpStatus } from "@/store/assistant/types";
import { normalizeStatusValue } from "@/pages/agent/utils/agent-status.utils";

const CLOSED_FOLLOW_UP_STATUS_VALUES = new Set<string>([
  AssistantFollowUpStatus.Fired,
  AssistantFollowUpStatus.Completed,
  AssistantFollowUpStatus.Canceled,
]);

/**
 * A follow-up is "closed" once it has fired or been resolved.
 *
 * Either of these counts as closed:
 * - the timestamps say it already happened (`firedAt` or `completedAt` is set)
 * - the status is in the closed set (fired, completed, canceled)
 *
 * Used to find the next *open* follow-up for a task or project, and to count
 * outstanding follow-ups in the agent surfaces.
 */
export const isClosedFollowUp = ({ followUp }: { followUp: AssistantFollowUpObservable }) =>
  Boolean(followUp.completedAt || followUp.firedAt) ||
  CLOSED_FOLLOW_UP_STATUS_VALUES.has(normalizeStatusValue({ status: followUp.status }));
